import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA027_Request,
  IAPI_STA027_Response,
} from "../../../type/apiType";

// 法人職員異動更新
const httpAPI_STA027 = async (
  param: IAPI_STA027_Request
): Promise<IAPI_STA027_Response> => {
  let res = await http.post(ApiUrl.API_STA027, {
    ...param,
  });
  return res.data;
};

export { httpAPI_STA027 };
